import { ref } from "vue";
import * as Sentry from "@sentry/vue";
import * as AuthenticationService from "@/services/AuthenticationService";

export function useUnlockUser() {
  const loading = ref(false);
  const unlockError = ref(null);

  async function unlockUser(unlockToken) {
    unlockError.value = null;

    try {
      loading.value = true;
      await AuthenticationService.unlockUser(unlockToken);
    } catch (error) {
      unlockError.value =
        error.response?.data?.message || "Unable to unlock your account";
      if (error.response?.data?.message !== "Invalid unlock token.") {
        Sentry.captureException(error);
      }
    } finally {
      loading.value = false;
    }
  }

  return {
    unlockUser,
    unlockError,
    loading,
  };
}
